// extracted by mini-css-extract-plugin
export var animationContainer = "_p7-0";
export var footer = "_p7-1";
export var gray = "_p7-2";
export var lineItem = "_p7-3";
export var lineItemImage = "_p7-4";
export var lineItemInfo = "_p7-5";
export var lineItemText = "_p7-6";
export var lineItems = "_p7-7";
export var modalContent = "_p7-8";
export var options = "_p7-9";
export var orderName = "_p7-a";
export var refundAmount = "_p7-b";